import { AutoRedPacketBetSettingScreenNavigationProps } from "./type"
import React from "react"
import AutoRedPacketBetSetting from "./auto-red-packet-bet-screen"
import { PageRoot } from "~screens/page-root"


const AutoRedPacketBetSettingScreen: React.FC<AutoRedPacketBetSettingScreenNavigationProps> = (props) => {
  return (
    <PageRoot>
      <AutoRedPacketBetSetting {...props}/>
    </PageRoot>
  )
}

export default AutoRedPacketBetSettingScreen
